import {
  Permission,
  usePermissionComposable,
} from '@/composables/usePermission';
import { NavigationGuard } from 'vue-router';

type PermissionGuard = (
  key: Permission,
  fallbackPathName: string
) => NavigationGuard;

export const permissionGuard: PermissionGuard =
  (key, fallbackPathName) => (_, __, next) => {
    const {
      hasPermission,
      PERMISSIONS: { [key]: permission },
    } = usePermissionComposable();
    if (!hasPermission(permission)) {
      return next({ name: fallbackPathName });
    }

    return next();
  };
